/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehearsing a 60-second elevator pitch to keep it tight enough for a real introduction.`)
};

const es_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensayar un discurso de ascensor de 60 segundos para que sea lo bastante conciso para una presentación real.`)
};

const de_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen 60-Sekunden-Elevator-Pitch proben, damit er kurz genug für eine echte Vorstellung bleibt.`)
};

const nl_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een elevator pitch van 60 seconden oefenen om hem kort genoeg te houden voor een echte introductie.`)
};

const fr_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répéter un pitch d’ascenseur de 60 secondes pour qu’il reste assez concis pour une véritable présentation.`)
};

const it_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provare un elevator pitch di 60 secondi per mantenerlo abbastanza conciso per una presentazione reale.`)
};

const pt_br2_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensaiar um discurso de elevador de 60 segundos para mantê-lo objetivo o suficiente para uma apresentação real.`)
};

const pt_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensaiar um discurso de elevador de 60 segundos para o manter suficientemente sucinto para uma apresentação real.`)
};

const ja_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実際の自己紹介で使えるよう簡潔にまとめるため、60秒のエレベーターピッチをリハーサルする。`)
};

const zh_timer_u1m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排练一段60秒的电梯演讲，确保内容足够精炼，适合正式自我介绍。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_use3", locale)
	if (locale === "en") return en_timer_u1m_use3(inputs)
	if (locale === "es") return es_timer_u1m_use3(inputs)
	if (locale === "de") return de_timer_u1m_use3(inputs)
	if (locale === "nl") return nl_timer_u1m_use3(inputs)
	if (locale === "fr") return fr_timer_u1m_use3(inputs)
	if (locale === "it") return it_timer_u1m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_use3(inputs)
	if (locale === "pt") return pt_timer_u1m_use3(inputs)
	if (locale === "ja") return ja_timer_u1m_use3(inputs)
	return zh_timer_u1m_use3(inputs)
};